import { createContext, useState, useCallback } from "react";

export const ChatContext = createContext();

const SESSION_KEYS = {
  threadId: "chat_threadId",
  messages: "chat_messages",
};

const getSessionMessages = () => {
  try {
    const stored = sessionStorage.getItem(SESSION_KEYS.messages);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const getSessionThreadId = () => {
  return sessionStorage.getItem(SESSION_KEYS.threadId) || null;
};

export function ChatProvider({ children }) {
  const chatEnabled = import.meta.env.VITE_CHAT_DISABLED !== "true";

  const [isOpen, setIsOpen] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [messages, setMessages] = useState(getSessionMessages);
  const [threadId, setThreadIdState] = useState(getSessionThreadId);
  const [isLoading, setIsLoading] = useState(false);

  const setThreadId = useCallback((id) => {
    setThreadIdState(id);
    if (id) {
      sessionStorage.setItem(SESSION_KEYS.threadId, id);
    } else {
      sessionStorage.removeItem(SESSION_KEYS.threadId);
    }
  }, []);

  const addMessage = useCallback((role, content) => {
    const newMessage = { role, content, timestamp: new Date().toISOString() };
    setMessages((prev) => {
      const updated = [...prev, newMessage];
      sessionStorage.setItem(SESSION_KEYS.messages, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const resetChat = useCallback(() => {
    setMessages([]);
    setThreadIdState(null);
    setIsLoading(false);
    sessionStorage.removeItem(SESSION_KEYS.messages);
    sessionStorage.removeItem(SESSION_KEYS.threadId);
  }, []);

  return (
    <ChatContext.Provider
      value={{
        chatEnabled,
        isOpen,
        setIsOpen,
        isPinned,
        setIsPinned,
        messages,
        threadId,
        setThreadId,
        isLoading,
        setIsLoading,
        addMessage,
        resetChat,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}
